import React, {useState,useEffect,createContext} from "react";

export const ConfigContext = createContext();

const ConfigProvider = (props) => {
    const [isVideo,setIsVideo] = useState(true);
    const [isAudio,setIsAudio] = useState(true);

    return (
        <ConfigContext.Provider value={{state: {isAudio,isVideo},setter: {setIsAudio,setIsVideo}}}>
            {props.children}
        </ConfigContext.Provider>
    );
}

export default ConfigProvider;